import React from 'react'
import '../styles/components.css'
import 'bootstrap/dist/css/bootstrap.min.css';
const SignupRectangle = (props) => {
    return (
        <div className='gradientRectangle'>
            <p>
                {"Experience business travel made for"}<br/>{"businesses like yours."}
            </p>
            <div>
                <input placeholder='Your work email' />
                <button className='buttonFull'>Sign up for free</button>
                <button className='buttonSmall'>Sign up</button>
            </div>
        </div>
    )
}

export default SignupRectangle;